import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME,
  AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_MAIN_ROUTE_NAME,
  AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_FIXED_PAYMENTS,
} from './constants';
import { ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT_ROUTE_NAME } from './submodules/fixed-payments-history-edit/constants';
import { AffiliatesApprovedFixedPaymentsHistoryChangesEditModule } from './submodules/fixed-payments-history-edit/FixedPaymentsHistoryEditModule';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedFixedTrackerPaymentsModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedFixedPaymentsHistoryChangesEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_MAIN_ROUTE_NAME,
      path: ':trackerId/fixed-tracker-payments',
      component: () => import('./pages/FixedTrackerPaymentsModalPage/FixedTrackerPaymentsModalPage.vue'),
      permission: AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS.HISTORY_CHANGES_EDIT,
      props: {
        backTo: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME },
        editHistoryRoute: { name: ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT_ROUTE_NAME },
        backFromEditHistoryRoute: { name: ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_MAIN_ROUTE_NAME },
        trackersListQueryKey: AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY,
      },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_FIXED_PAYMENTS, getTranslationKeys);
  }
}
